import {
  Button as MuiButton,
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import VersionsTable from "./VersionsTable";

const VersionsModal = ({ isOpen, onClose, protocolNumber, versions }) => {
  const { t } = useTranslation();

  return (
    <MuiDialog
      open={isOpen}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          width: "100%",
          maxWidth: "750px"
        },
      }}
    >
      <MuiDialogTitle
        id="pep-study-recruitment-versions"
        sx={{
          padding: "16px 24px",
          fontSize: "18px",
        }}
      >
        {t("studyRecruitment.versions.title", {
          protocolNumber,
        })}
      </MuiDialogTitle>

      <MuiDialogContent
        sx={{
          borderTop: "1px solid #0000001f",
          borderBottom: "1px solid #0000001f",
          padding: "24px",
          height: "auto",
        }}
      >
        <VersionsTable versions={versions} />
      </MuiDialogContent>

      <MuiDialogActions>
        <MuiButton onClick={onClose} color="primary" sx={{ fontSize: "17px" }}>
          {t("buttons.caps.close")}
        </MuiButton>
      </MuiDialogActions>
    </MuiDialog>
  );
};

export default VersionsModal;
